import styled from '@react-pdf/styled-components';

export const Container = styled.View`
  width: 100%;
  height: 110px;
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const ContainerIMG = styled.View`
  border-radius: 50px;
  max-width: 80px;
  width: 80px;
  height: 80px;
  border: 1px solid #C4C4C4;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Logo = styled.Image`
  max-width: 50px;
  width: 60px;
  height: 60px;
`;

export const ContainerTitle = styled.View`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 25px;
`;
